// import getBannerRow from "../DataDisplayRow/BannerRow";
import getSplashScreenRow from "../DataDisplayRow/SplashScreenRow";
import DataDisplayRowI from "../DataDisplayRowI";
import DataDisplayTable from "../DataDisplayTable";

class SplashScreenRowTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getSplashScreenRow()
    }
}

let pdfSplashScreenTable: SplashScreenRowTable | null = null;

export default function getSplashScreenTable(): SplashScreenRowTable {
    if (pdfSplashScreenTable === null)
        pdfSplashScreenTable = new SplashScreenRowTable()
    return pdfSplashScreenTable
}